// Imports
import parseMarkdown from './parse';
import sanitizeMarkdown, { SanitizeOptions } from './sanitize';


// Options
interface ParseAndSanitizeOptions {
	/** Options that will be passed directly to `sanitizeMarkdown`. */
	sanitizeOptions?: SanitizeOptions;
}


/** Parse a string as Markdown into HTML, and then sanitize it */
export default function parseAndSanitizeMarkdown(markdown: string, options?: ParseAndSanitizeOptions): string {
	return sanitizeMarkdown(parseMarkdown(markdown), options?.sanitizeOptions);
}
